/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S2_Terminate_DescInputs */

const tr_iade_iptal_s2_terminate_desc = /** @type {(inputs: Iade_Iptal_S2_Terminate_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abone'nin açık talebi üzerine Abonelik'in derhal sona erdirilmesi; kalan süre için iade 3. ve 5. maddelere tabidir.`)
};

const en_iade_iptal_s2_terminate_desc = /** @type {(inputs: Iade_Iptal_S2_Terminate_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The immediate ending of the Subscription at the Subscriber's express request; any refund for the remaining time is subject to clauses 3 and 5.`)
};

const de_iade_iptal_s2_terminate_desc = /** @type {(inputs: Iade_Iptal_S2_Terminate_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die sofortige Beendigung des Abonnements auf ausdrücklichen Wunsch des Abonnenten; eine Erstattung für die verbleibende Zeit richtet sich nach den Ziffern 3 und 5.`)
};

const ru_iade_iptal_s2_terminate_desc = /** @type {(inputs: Iade_Iptal_S2_Terminate_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Немедленное прекращение Подписки по явному требованию Абонента; возврат за оставшийся срок регулируется пунктами 3 и 5.`)
};

/**
* | output |
* | --- |
* | "The immediate ending of the Subscription at the Subscriber's express request; any refund for the remaining time is subject to clauses 3 and 5." |
*
* @param {Iade_Iptal_S2_Terminate_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s2_terminate_desc = /** @type {((inputs?: Iade_Iptal_S2_Terminate_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S2_Terminate_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s2_terminate_desc(inputs)
	if (locale === "de") return de_iade_iptal_s2_terminate_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s2_terminate_desc(inputs)
	return tr_iade_iptal_s2_terminate_desc(inputs)
});